export default __webpack_public_path__ + "static/media/Wicungo1.61d6be90.jpg";